export default {"src":"/_next/static/media/ic_arrow_new_disabled.28a9f7ac.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};